export const globalConstant = {
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  SET_PROFILE: "SET_PROFILE",
  SET_IS_OPEN_MODAL_LOGIN: "SET_IS_OPEN_MODAL_LOGIN",
  SET_IS_OPEN_MODAL_REGISTER: "SET_IS_OPEN_MODAL_REGISTER",
  SWITCH_LOGIN_TO_REGISTER: "SWITCH_LOGIN_TO_REGISTER",
  SWITCH_REGISTER_TO_LOGIN: "SWITCH_REGISTER_TO_LOGIN",
};
